<div class="goal-container">
  <!-- 🎯 Wrapper para goal-widget + notificação terem mesma largura -->
  <div class="goal-wrapper">
    <div class="goal-widget" 
         [style.color]="textColor"
         [style.background]="backgroundColor">
      
      <!-- Título/Descrição da meta -->
      <div class="goal-title"
           [style.color]="textColor">
        {{ descricao }}
        <span *ngIf="shouldShowNextStep && nextStepDescription" 
              class="next-goal-preview"
              [style.color]="textColor">
          / {{ nextStepDescription }}
        </span>
      </div>
      
      <!-- Barra de progresso com texto interno -->
      <div class="progress-container">
        <div class="progress-bar-background">
          <div class="progress-bar-fill" 
               [style.width.%]="progressoPercentual"
               [style.background-color]="barColor"
               [@progressAnimation]="progressoPercentual">
          </div>
          <!-- Texto sobreposto na barra -->
          <div class="progress-text-overlay"
               [style.color]="valueColor">
            <span class="current-progress">{{ progressoTexto }}</span>
            <span class="percentage">{{ progressoPercentual | number:'1.0-0' }}%</span>
          </div>
        </div>
      </div>
      
      <!-- Explosão de ícones quando meta atingida (se habilitado) -->
      <div class="icon-explosion-container" *ngIf="metaAtingida && showExplosion">
        <div class="explosion-icon" 
           *ngFor="let icon of explosionIcons; let i = index"
           [style.animation-delay.ms]="i * 100"
           [@explosionAnimation]="explosionState">
          <span *ngIf="icon.type === 'emoji'">{{ icon.content }}</span>
          <img *ngIf="icon.type === 'image'" [src]="icon.content" [alt]="icon.alt">
        </div>
      </div>
      
      <!-- Texto de meta atingida (se habilitado e configurado) -->
      <div class="goal-completed-text" 
           *ngIf="metaAtingida && showGoalText && goalCompletedText"
           [style.color]="textColor"
           [@textFadeIn]="metaAtingida">
        {{ goalCompletedText }}
      </div>
      
    </div> <!-- Fecha goal-widget -->

    <!-- 🎯 Notificação com duplo ícone (Platform + Type) -->
    <div class="event-notification" *ngIf="showNotification">
      <div class="event-content" 
           [style.background]="backgroundColor" 
           [style.color]="textColor"
           [style.border-left-color]="notificationData?.platformColor">
        
        <!-- Ícones (Plataforma + Tipo) -->
        <div class="event-icons">
          <img *ngIf="notificationData?.platformIconPath" 
               class="platform-icon" 
               [src]="notificationData?.platformIconPath"
               alt="Platform Icon">
          
          <!-- Type icon: suporta Material Icon ou imagem PNG -->
          <span *ngIf="notificationData?.typeIcon" 
                class="type-icon material-icons">{{ notificationData?.typeIcon }}</span>
          <img *ngIf="notificationData?.typeIconPath" 
               class="type-icon-image" 
               [src]="notificationData?.typeIconPath"
               alt="Type Icon">
        </div>
        
        <!-- Texto -->
        <span class="event-text">
          <strong>{{ notificationData?.contributorName }}</strong>
          <span class="event-value" [style.color]="notificationData?.platformColor">{{ notificationData?.displayValue }}</span>
        </span>
      </div>
    </div>

  </div> <!-- Fecha goal-wrapper -->
  
  <!-- 🔧 Botões de teste (somente em dev) -->
  <div class="test-controls" *ngIf="isLocal" style="position: fixed; bottom: 10px; right: 10px; display: flex; flex-direction: column; gap: 5px;">
    <button mat-raised-button color="primary" (click)="onTestExplosion()">
      🎆 Test Explosion
    </button>
    <button mat-raised-button color="accent" (click)="onTestNotification()">
      ⭐ Test Twitch Sub
    </button>
    <button mat-raised-button color="warn" (click)="onTestDonation()">
      💰 Test Donation
    </button>
    <button mat-raised-button (click)="onTestSale()">
      🛒 Test Sale
    </button>
    <button mat-raised-button style="background-color: #FF0000; color: white;" (click)="onTestYoutubeMember()">
      🎬 Test YouTube Member
    </button>
    <button mat-raised-button style="background-color: #FF0000; color: white;" (click)="onTestYoutubeSuperChat()">
      💬 Test YouTube Super Chat
    </button>
  </div>
  
</div>